import { palette } from '@dev/ee-components';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const IconWrapper = styled.div`
    height: 240px;
    border: 1px solid ${palette.gray[3]};
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TitleWrapper = styled.div`
    display: inline-flex;
    margin-top: 32px;
    margin-left: 16px;
    margin-bottom: 10px;
`;

export const ContentBoxWrapper = styled.div`
    cursor: pointer;

    &:hover {
        & > div:first-child {
            box-shadow: 2px 3px 10px #6665b93d;
        }
    }
`;

export const StyledGrid = styled(Grid)`
    flex-basis: 0;
    flex-grow: 1;
`;